import { Helmet } from 'react-helmet-async';
import { SEO_CONFIG } from '../../config/seo.config';

const SEO = ({ 
  title, 
  description, 
  keywords = '', 
  image = SEO_CONFIG.site.defaultImage,
  url = '',
  type = 'website'
}) => {
  const siteName = SEO_CONFIG.site.name;
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const fullUrl = url ? `${SEO_CONFIG.site.url}${url}` : SEO_CONFIG.site.url;
  const fullImage = image.startsWith('http') ? image : `${SEO_CONFIG.site.url}${image}`;

  return (
    <Helmet>
      {/* Meta tags de base */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Autres meta tags importants */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content={siteName} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Favicon et icônes */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/logo192.png" />
      
      {/* Schema.org pour les restaurants */}
      <script type="application/ld+json">
        {JSON.stringify(SEO_CONFIG.schema.restaurant)}
      </script>
    </Helmet>
  );
};

export default SEO; 